import {
  GiWaterDrop,
  GiCalendar,
  GiStopwatch,
  GiNotebook,
  GiChatBubble,
  GiPhone,
} from "react-icons/gi";
import { FaQuestion } from "react-icons/fa";
import massageImage from "../../assets/images/massage.jpg";
import { LandingContent } from "./types";

export const massageContent: LandingContent = {
  seo: {
    title: "Masszőrök online időpontfoglaló | Wobble",
    description:
      "Könnyű és gyors online időpontfoglaló rendszer masszőrök számára. Kezeld hatékonyan vendégeidet és időbeosztásod a Wobble segítségével!",
    ogTitle: "Wobble - Masszőrök időpontfoglaló rendszere",
    ogDescription:
      "Egyszerű foglalás, automatikus értesítések és gördülékeny ügyfélkezelés egy helyen – növeld vendégeid számát és spórolj időt!",
    keywords: "masszőr, időpontfoglalás, online foglalás, wellness, Wobble",
    image: "../assets/mockup_massage.png",
  },
  header: {
    heading: "Online időpontfoglaló rendszer masszőröknek",
    subheading:
      "Hatékony időpontfoglaló rendszer masszőröknek – egyszerű, gyors és ügyfélközpontú megoldás a Wobble-tól.",
    highlightText: "Wobble masszőröknek",
  },
  problems: {
    title: "Ismerős problémák?",
    features: [
      { icon: GiNotebook, text: "Foglalások nyilvántartása papíron vagy fejben, ami könnyen átláthatatlan." },
      { icon: GiChatBubble, text: "Vendégek nehezen tudják meg szabad időpontjaidat vagy kérdéseiket nem válaszolod meg időben." },
      { icon: GiStopwatch, text: "Az időpontok szervezése sok időt és energiát vesz el a kezelések közül." },
      { icon: FaQuestion, text: "Szeretnéd csökkenteni a lemondásokat és az ismétlődő egyeztetéseket." },
      { icon: GiCalendar, text: "Nincs egyszerű eszközöd a kezelési típusok és extra szolgáltatások foglalására." },
    ],
    summaryText:
      "A Wobble időpontfoglaló rendszerével könnyedén átlátható és hatékony lesz a masszázs időpontok kezelése.",
    cta: {
      href: "https://app.wobble.hu/signup_page",
      label: "Kipróbálom ingyen",
    },
    imageSrc: massageImage,
    imageAlt: "Masszőr online időpontfoglalás",
  },
  whyDigitalize: {
    title: "Miért érdemes digitalizálni?",
    features: [
      { icon: GiPhone, text: "Az ügyfelek egyre inkább az online foglalást preferálják." },
      { icon: GiStopwatch, text: "A Wobble segítségével bármikor könnyedén foglalhatnak időpontot." },
      { icon: GiChatBubble, text: "Automatikus visszaigazolások és emlékeztetők csökkentik az elfeledett időpontot." },
      { icon: GiNotebook, text: "Foglaláskor kérdőív, hogy még felkészültebb legyél az ügyfél igényéről." },
      { icon: GiCalendar, text: "Átlátható szolgáltatások listája és egyszerű adminisztráció egy helyen." },
    ],
  },
  whyTheyLove: {
    title: "Hogyan segít a Wobble a masszőrök munkájában?",
    imageSrc: "../assets/mockup_massage.png",
    imageAlt: "Masszőr online időpontfoglalás",
    features: [
      { icon: GiWaterDrop, text: "Gyors és egyszerű időpontkezelés" },
      { icon: GiCalendar, text: "Kezelések és extra szolgáltatások testreszabása" },
      { icon: GiStopwatch, text: "Automatikus emlékeztetők és visszaigazolások" },
      { icon: GiChatBubble, text: "Bármennyi szolgáltatás speciális opciók és kérdőív támogatással" },
      { icon: GiNotebook, text: "Online jelenlét támogatása időpontfoglaló rendszerrel és blogolási lehetőséggel" },
    ],
  },
  trial: {
    title: "💆‍♂️ Csatlakozz most",
    title2: "30 nap ingyenes próbaidőszak!",
    subtitle:
      "Próbáld ki a Wobble-t kockázat nélkül, bankkártya megadása nélkül!",
    cta: {
      href: "https://app.wobble.hu/signup_page",
      label: "Regisztrálok most",
    },
  },
};
